import axios from 'axios';
import config from '../config';
import { ProcessedMapListItem } from '../interfaces';

export const getProcessedMaps = (): Promise<ProcessedMapListItem[]> => {
    const url = `${config.API_URL}/maps/processed-maps`;

    return axios.get(url).then((response: any) => {
        return response.data.data.processedMaps;
    });
};
